export enum LanguageCode {
  sv,
  en,
}